import React from "react";
import CardPreLoader from "../../dashbord/CardPreLoader";
import BiWeekSaleAnalytics from "./weeksale/BiWeekSaleAnalytics";
import DayOfWeeklySales from "./weeksale/DayOfWeeklySales";
import WeekSaleAnalytics from "./weeksale/WeekSaleAnalytics";
import { RefreshIcon } from "../../../../constants/Icons";

function WeeklySale({
  biWeekData,
  weeklyHourlyData,
  onRefreshBiWeek,
  isDayofWeekData,
  onRefreshWeeklyHourly,
  onRefreshWeeklydayofweek,  
  loading,
  fetchStatus
}) {
  return (
    <div>
      <div className="card mb-2">
        <div className="card-header bg-transparent p-3-75 border-0">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0 font-18">Weekly Sales</h5>
            <button
              type="button"
              className="btn btn-sm btn-light pull-right shadow-none"
              onClick={() => onRefreshBiWeek(true)}
            >
              Refresh <RefreshIcon/>
            </button>
          </div>
        </div>
        <div className="card-body position-relative">
          <CardPreLoader isLoading={loading.isLoading} />

          <BiWeekSaleAnalytics AnalyticsData={biWeekData} />
        </div>
      </div>

      <div className="card mb-2">
        <div className="card-header bg-transparent p-3-75 border-0">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0 font-18">Weekly Sales by Hour</h5>
            <button
              type="button"
              className="btn btn-sm btn-light pull-right shadow-none"
              onClick={() => onRefreshWeeklyHourly(true)}
            >
              Refresh <RefreshIcon/>
            </button>
          </div>
        </div>
        <div className="card-body position-relative">
           {!fetchStatus.daterangeByHours && !loading.byHours && (
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
              style={{
                backgroundColor: 'rgb(255 255 255 / 62%)',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 2,
              }}
            >
              <button
                type="button"
                className="btn btn-sm btn-light pull-right font-20"
                onClick={() => onRefreshWeeklyHourly(true)}
              >
                Refresh <RefreshIcon iClass={"font-24"}/>
              </button>
            </div>
          )}
          <CardPreLoader isLoading={loading.byHours} />
          <WeekSaleAnalytics AnalyticsData={weeklyHourlyData} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-4">
          <div className="card mb-2">
            <div className="card-header bg-transparent p-3-75 border-0">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0 font-18">Weekly Sales by Day </h5>
                <button
                  type="button"
                  className="btn btn-sm btn-light pull-right shadow-none"
                  onClick={() => onRefreshWeeklydayofweek(true)}
                >
                  Refresh <RefreshIcon/>
                </button>
              </div>
            </div>
            <div className="card-body position-relative">
              {!fetchStatus.dateRangeByDays && !loading.byDayOfWeek && (
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
              style={{
                backgroundColor: 'rgb(255 255 255 / 62%)',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 2,
              }}
            >
              <button
                type="button"
                className="btn btn-sm btn-light pull-right font-20"
                onClick={() => onRefreshWeeklydayofweek(true)}
              >
                Refresh <RefreshIcon iClass={"font-24"}/>
              </button>
            </div>
          )}
              <CardPreLoader isLoading={loading.byDayOfWeek} />
              <DayOfWeeklySales AnalyticsData={isDayofWeekData?.saleData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeeklySale;
